import React, { useState } from 'react'
import {
  Dialog,
  DialogActions as MuiDialogActions,
  DialogContent,
  DialogTitle,
  Button as MuiButton,
  TextField as MuiTextField,
} from '@material-ui/core'
import styled from 'styled-components'
import { spacing } from '@material-ui/system'
import TextRows from '../../components/TextRows'

const Button = styled(MuiButton)(spacing)
const DialogActions = styled(MuiDialogActions)(spacing)

const TextRowsWrapper = styled.div`
  height: 400px;
`


export default function AddDomainsDialog({ open, onSave, onClose }) {
  const [domains, setDomains] = useState([])
  const [errors, setErrors] = useState([])
  const [thinking, setThinking] = useState(false)

  const onChange = (rows, errors) => {
    setDomains(rows)
    setErrors(errors)
  }

  const onConfirm = () => {
    if (!domains.length || !!errors.length) return
    setThinking(true)
    onSave(domains).then((success) => {
      setThinking(false)
      if (success) {
        setDomains([])
        onClose()
      }
    })
  }

  return (
    <Dialog
      fullWidth
      maxWidth='sm'
      data-cy='dialogContactContacts'
      open={open}
      aria-labelledby='max-width-dialog-title'
    >
      <DialogTitle id="max-width-dialog-title">Add domains to blocklist</DialogTitle>
      <DialogContent>
        <TextRowsWrapper>
          <TextRows
            thinking={thinking}
            validation={'competitors'}
            helpText={'Type one domain per line'}
            placeholder={'e.g. example.com'}
            values={domains}
            errors={errors}
            onChange={onChange} />
        </TextRowsWrapper>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={() => onClose()}>Cancel</Button>
        <Button color="primary" variant="contained" disabled={!domains.length || !!errors.length} onClick={onConfirm}>Add</Button>
      </DialogActions>
    </Dialog>
  )
}